module.exports = __webpack_public_path__ + "img/neck_female.d882556f.png";